var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVocaltracks = function SvgVocaltracks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 40,
    viewBox: "0 0 27 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f7f4f9",
    d: "M18.002 32.963c-4.983 0-9.038-4.055-9.038-9.038v-10.14c0-4.983 4.055-9.038 9.038-9.038s9.039 4.055 9.039 9.038v10.14c0 4.983-4.055 9.038-9.04 9.038z",
    className: "shadow"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#dac7fa",
    d: "M13.385 32.651c-7.405 0-13.429-6.025-13.429-13.43a1.385 1.385 0 1 1 2.77 0c0 5.878 4.781 10.66 10.66 10.66 5.875 0 10.657-4.782 10.657-10.659a1.385 1.385 0 1 1 2.77 0c0 7.404-6.023 13.429-13.428 13.429"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#dac7fa",
    d: "M19.653 9.167v10.14a6.275 6.275 0 0 1-6.268 6.268 6.275 6.275 0 0 1-6.268-6.268V9.167A6.275 6.275 0 0 1 13.385 2.9a6.275 6.275 0 0 1 6.268 6.267m2.77 10.14V9.167c0-4.983-4.055-9.038-9.038-9.038S4.346 4.184 4.346 9.167v10.14c0 4.984 4.055 9.039 9.04 9.039 4.982 0 9.037-4.055 9.037-9.04z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#dac7fa",
    d: "M10.326 13.179H5.732a1.385 1.385 0 1 1 0-2.77h4.594a1.386 1.386 0 0 1 0 2.77M10.326 18.067H5.732a1.385 1.385 0 1 1 0-2.77h4.594a1.386 1.386 0 0 1 0 2.77M13.385 39.87c-.765 0-1.385-.62-1.385-1.385v-6.67a1.385 1.385 0 1 1 2.77 0v6.67c0 .765-.62 1.386-1.385 1.386z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#dac7fa",
    d: "M21.909 39.87H4.86a1.386 1.386 0 0 1 0-2.77h17.048a1.386 1.386 0 0 1 0 2.77z"
  })));
};
export default SvgVocaltracks;